import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VParallax } from 'vuetify/lib/components/VParallax';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.item ? _c('div', [_c(VCard, {
    staticClass: "mt-0 mb-8 preview",
    staticStyle: {
      "overflow": "hidden"
    }
  }, [_c('div', [_c(VParallax, {
    attrs: {
      "height": _vm.parallaxHeight,
      "src": _vm.headerBG
    }
  }, [_c('h3', {
    staticClass: "pl-3 pr-3 title-frame header-text text-truncate"
  }, [!_vm.showSkeletonLoader && _vm.item.faIcon && _vm.item.faIcon.trim().length > 0 ? _c(VIcon, {
    class: _vm.color + '--text headline-icon mr-1',
    domProps: {
      "textContent": _vm._s(`fal fa-${_vm.item.faIcon}`)
    }
  }) : _vm._e(), _vm._v("\n          " + _vm._s(_vm.item.title) + "\n        ")], 1)])], 1), _c('div', {
    staticStyle: {
      "height": "0px",
      "overflow": "visible",
      "position": "relative",
      "top": "-60px",
      "right": "16px",
      "float": "right"
    }
  }, [_c('div', {
    staticClass: "actions-gradient px-2",
    staticStyle: {
      "height": "60px"
    }
  }, [!_vm.showSkeletonLoader ? [_vm.mapmode ? _c('core-button', {
    attrs: {
      "color": _vm.color,
      "prepend-icon": "fa-edit"
    },
    on: {
      "click": function ($event) {
        return _vm.openDetails(_vm.item);
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('NiotaClassic.GWMonitoring.details.viewDetails')) + "\n          ")]) : _vm._e(), _vm.mapmode ? _c('core-button', {
    attrs: {
      "color": "danger",
      "title": _vm.$i18n_t('Common.cancel'),
      "prepend-icon": "fa-times"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('cancel');
      }
    }
  }) : _vm._e()] : [_c(VSkeletonLoader, {
    attrs: {
      "type": "actions"
    }
  })]], 2)]), _c(VCardText, [_c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VSimpleTable, {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function () {
        return [_c('thead', [_c('tr', [_c('th'), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_t('NiotaClassic.GWMonitoring.packetsFrom24Hr')) + "\n                  ")]), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_t('NiotaClassic.GWMonitoring.lastPacket')) + "\n                  ")]), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.table.rssi')) + "\n                  ")]), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.table.lsnr')) + "\n                  ")])])]), _c('tbody', [_c('tr', [_c('td', {
          staticClass: "px-0 text-center",
          staticStyle: {
            "width": "10px"
          }
        }, [_c(VIcon, {
          attrs: {
            "small": "",
            "color": _vm.item.color
          }
        }, [_vm._v("fal fa-circle")])], 1), _c('td', [_vm._v(_vm._s(_vm.item.countPackets || 0))]), _c('td', [_vm._v(_vm._s(_vm.lastPacket(_vm.item.lastPacket)))]), _c('td', [_vm._v(_vm._s(_vm.getRssi(_vm.item)))]), _c('td', [_vm._v(_vm._s(_vm.getLsnr(_vm.item)))])])])];
      },
      proxy: true
    }], null, false, 1666815915)
  }), _c(VDivider, {
    staticClass: "mt-2"
  }), _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('NiotaClassic.GWMonitoring.gwEui')) + ": " + _vm._s(_vm.item.eui) + "\n              "), !_vm.showSkeletonLoader ? [_vm._v("\n                " + _vm._s(_vm.$i18n_t('NiotaClassic.GWMonitoring.form.serialNr')) + ": " + _vm._s(_vm.item.serialNr) + "\n              ")] : _vm._e()], 2)], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };